import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { SCENE_DIAMETER } from './constants'

export default function CameraRig() {
  const { camera, size } = useThree()

  useEffect(() => {
    if (!(camera instanceof THREE.OrthographicCamera)) return

    camera.position.set(0, 48, 0)
    camera.up.set(0, 0, -1)
    camera.lookAt(0, 0, 0)
    camera.zoom = Math.min(size.width, size.height) / SCENE_DIAMETER
    camera.near = 0.1
    camera.far = 120
    camera.updateProjectionMatrix()
  }, [camera, size.height, size.width])

  return null
}

